<template>
  <div class="page-header-bar py-4 px-6">
    <div class="review-title-and-breadcrumbs">
      <div class="review-title">
        <router-link
          v-if="rootRoute"
          :to="rootRoute"
          class="text-decoration-none black--text"
        >
          <slot></slot>
        </router-link>
        <slot v-else></slot>
      </div>
      <div v-if="breadcrumb" class="breadcrumbs">
        <v-icon>chevron_right</v-icon>
        <span class="font-weight-medium">{{ breadcrumb }}</span>
      </div>
    </div>
    <div>
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeaderBar',
  props: {
    breadcrumb: {
      type: String,
      default: null,
    },
    rootRoute: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.page-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;

  // Defined in src/scss/variables.scss
  height: $page-header-bar-height;

  background-color: white;
  border-bottom: 1px solid map-get($grey, 'lighten-2');

  .review-title-and-breadcrumbs {
    @extend .d-flex, .flex-nowrap, .flex-grow-1;
    @extend .text-h6, .font-weight-bold;
    @extend .mr-4;
    overflow: hidden;

    .review-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .breadcrumbs {
      white-space: nowrap;
    }
  }
}
</style>
